import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100",
  height: "100",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#29B6F6",
  d: "M45 14.3c-.2 4.1-3 9.6-8.6 16.6-5.7 7.4-10.5 11-14.5 11-2.4 0-4.5-2.2-6.2-6.7-1.1-4.1-2.3-8.2-3.4-12.3-1.3-4.5-2.6-6.7-4-6.7-.3 0-1.4.5-3.3 1.8l-2-2.3c2.1-1.8 4-3.1 6-4.9 2.8-2.4 4.8-3.6 6.2-3.7q4.95-.45 6 6.6c.8 5.1 1.5 7.8 1.8 9 .9 4.2 2 6.4 3.1 6.4.9 0 2.2-1.4 4-4.1 1.8-2.8 2.7-4.8 2.8-6.3.3-2.4-.7-3.6-2.8-3.6-1 0-2.1.5-3.2.9C29 9.3 33 5.8 38.8 6c4.4.1 6.4 2.9 6.2 8.3"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }